import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { DASH } from "../../lib/constants.js";

export default function DataBoxItemRow({
  id,
  isHost,
  route,
  state,
  title,
  value,
}) {
  return (
    <Box id={id} display="flex" alignItems="center" gap={2}>
      <Typography
        color="secondary"
        variant="body2"
        sx={{ textTransform: "uppercase", letterSpacing: 1 }}
      >
        {title}
      </Typography>
      <Typography
        component={isHost || !route ? null : Link}
        state={state}
        textTransform="capitalize"
        to={route}
        variant="body2"
      >
        {value || DASH}
      </Typography>
    </Box>
  );
}
